export const employeeTableHeader = [
  { id: 'name', label: 'Name', minWidth: 170 },
  { id: 'designation', label: 'Designation', minWidth: 200 },
  { id: 'email', label: 'Email', minWidth: 250 },
  { id: 'contact', label: 'Contact', minWidth: 150 },
  { id: 'extension_no', label: 'Extension No', minWidth: 150 },
];
